<template>
  <div class="score">
    <Loading v-if="loading" />
    <div class="bgc top_div">
      <div class="title">
        <div class="sort_son_title">
          {{ itemTitle }}
        </div>
        <div class="right_div">
          <a-button
            v-if="data && data.length"
            class="btn"
            type="primary"
            ghost
            @click="importTo"
          >
            {{ $t('exam.downbtn') + itemTitle + $t('exam.biao') }}
          </a-button>
        </div>
      </div>
      <div v-show="data.length" class="echarts">
        <div :id="id" class="echarts_list"></div>
      </div>
      <NotData v-if="!data.length && !loading" />
    </div>
    <div v-if="data && data.length" class="bgc table_div">
      <Table
        :columns="columns"
        :pagination="false"
        :data="data"
        :custom-row="customRow"
      />
    </div>
  </div>
</template>

<script>
  import axios, { getCookie } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/sortTable.vue'
  import * as echarts from 'echarts'
  import Loading from '@comp/loading'
  import { getCol } from '@utils/unite.js'

  export default {
    name: 'ClassTotal',
    components: {
      Table,
      Loading
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      itemTitle: {
        type: String,
        default: ''
      },
      cache: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        columns: [],
        columnsS: [
          {
            title: this.$t('exam.classGroup'),
            dataIndex: 'ClassGroup',
            key: 'ClassGroup',
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('exam.className'),
            dataIndex: 'ClassName',
            key: 'ClassName',
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('exam.studentNum'),
            dataIndex: 'StudentNum',
            key: 'StudentNum',
            width: 100,
            ellipsis: true
          },
          {
            title:
              this.$route.query.seId == 0
                ? this.$t('exam.ClassTeacher')
                : this.$t('exam.teacher'),
            dataIndex: 'ClassTeacher',
            key: 'ClassTeacher',
            width: 120
          }
        ],
        columnsSU: [
          {
            title: this.$t('exam.className'),
            dataIndex: 'ClassName',
            key: 'ClassName',
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('exam.studentNum'),
            dataIndex: 'StudentNum',
            key: 'StudentNum',
            width: 100,
            ellipsis: true
          }
        ],
        data: [],
        // chartList: [],
        arrMinScore: [],
        arrMaxScore: [],
        splitNum: 7,
        barRadius: [6, 6, 0, 0],
        titles: [],
        str: '',
        currentClass: {},
        charts: null,
        cacheData: false //是否缓存数据
      }
    },
    watch: {
      $route: {
        handler(newData, oldData) {
          var groupStatus = newData.query.dId === oldData.query.dId
          var subjectStatus =
            newData.query.subjectId === oldData.query.subjectId
          if (
            groupStatus &&
            subjectStatus &&
            newData.query.classId !== oldData.query.classId
          ) {
            this.cacheData = true
          }
          if (this.$route.query.classId || this.$route.query.seId) {
            this.getTable()
          }
        }
      }
    },
    mounted() {
      this.str =
        this.id == 'chartH' ? this.$t('exam.scoreNum') : this.$t('exam.rankSeg')
      this.getTable()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      resizeChart() {
        if (this.charts) this.charts.resize()
      },
      customRow(record) {
        let className =
          this.$route.query.classId * 1 &&
          record.ClassID == this.$route.query.classId
            ? 'current'
            : ''
        return className
      },
      beforeEchart(data, yTitle, params = {}) {
        let {
          split = true,
          splitNum = this.splitNum,
          abs = false,
          labelFc = null
        } = params
        let top
        if (data.legend && data.legend.data) {
          let baseNum = Math.ceil(data.legend.data.length / 10)
          top = baseNum * 25 + 34
        }
        //echarts距离处理
        data.grid = {
          top: data.legend.data.length ? top : 34,
          bottom: 28,
          left: '3.5%',
          right: '3.5%'
        }
        //x轴处理
        if (Array.isArray(data.xAxis)) {
          data.xAxis.forEach(item => {
            xDataDispose(item)
          })
        } else {
          xDataDispose(data.xAxis)
        }
        //x轴数据处理
        function xDataDispose(xData) {
          if (!xData.axisLabel) xData.axisLabel = {}
          xData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 14
          }
          xData.axisTick = {
            show: false
          }
          !xData.offset && (xData.offset = 4)
          if (!xData.axisLine) {
            xData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          }
        }

        //Y轴处理
        if (!data.yAxis) data.yAxis = {}
        if (Array.isArray(data.yAxis)) {
          data.yAxis.forEach(item => {
            yDataDispose(item)
          })
        } else {
          yDataDispose(data.yAxis)
        }
        //y轴数据处理
        function yDataDispose(yData) {
          if (!yData.splitLine) {
            yData.splitLine = {
              show: false
            }
          }

          if (!yData.axisLabel) yData.axisLabel = {}
          yData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 12
          }
          if (!yData.axisLine) {
            yData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              },
              itemStyle: {
                color: '#666666'
              }
            }
          }
          if (!yData.splitArea) {
            yData.splitArea = {
              show: true,
              areaStyle: {
                color: ['#A78BFA', '#fff'],
                opacity: 0.04
              }
            }
          }
        }

        //分割处理

        if (split) {
          let max = yTitle
          if (Array.isArray(yTitle)) {
            max = Math.max(...yTitle)
          }
          if (Array.isArray(data.yAxis)) {
            data.yAxis.forEach(item => {
              labelDispose(item, max)
            })
          } else {
            let splitVal = max / splitNum
            if (abs) splitVal = splitVal * 2
            data.yAxis.max = max
            data.yAxis.interval = splitVal
            labelDispose(data.yAxis, max)
          }
        }
        function labelDispose(label, max) {
          //label处理
          label.axisLabel.formatter = value => {
            var texts = []
            let nums = Math.floor(max / splitNum)
            texts.push(+value.toFixed(nums ? 0 : 1) + (labelFc && labelFc()))
            return texts
          }
        }
      },
      //图表滚动条
      cScroll(data, xTitle, num) {
        //如果超过num个则显示滚动条
        if (xTitle.length >= num) {
          let endVal = num === 1 ? 5 : +(100 * (num / xTitle.length)).toFixed(2)
          data.grid.bottom = 64
          data.dataZoom = [
            {
              start: 0, //默认为0
              end: endVal, //默认为100
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              handleIcon: `M 100, 100
                                 m -75, 0
                                 a 75,75 0 1,0 150,0
                                 a 75,75 0 1,0 -150,0`,
              handleSize: '85%',
              handleStyle: {
                color: '#ddeeff',
                borderWidth: 0
              },
              moveHandleSize: 0, //移动手柄尺寸高度
              height: 8, //组件高度
              left: 30, //左边的距离
              right: 40, //右边的距离
              bottom: 14, //底部的距离
              fillerColor: 'rgba(203, 214, 255, 0.6)', //线条颜色
              borderColor: 'transparent', //线条边框颜色
              backgroundColor: '#F8F8F8', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
              brushSelect: false //关闭十字架选中
            }
          ]
        }
      },
      renderChart(legendData, list, seriesData) {
        let _this = this
        let avg = []
        let legendBs = Math.ceil(legendData.length / 10)
        let legendHeight = 370 + legendBs * 30
        this.data.forEach(item => {
          item.ScoreList.forEach(sc => {
            avg.push(sc.Num)
          })
        })
        // let endVal = this.titles.length
        // if (this.titles.length > 10) {
        //   endVal = 100 * (10 / this.titles.length).toFixed(2)
        // }
        let lenObj = {}
        legendData.forEach(item => {
          if (
            this.currentClass.ClassName &&
            this.currentClass.ClassName != item &&
            (item != '年级' || item != '年級')
          ) {
            lenObj[item] = false
          }
        })
        this.$nextTick(() => {
          this.charts = echarts.init(document.getElementById(this.id))
          let option = {
            color: this.$store.state.echartsColor,
            tooltip: {
              trigger: 'axis',
              confine: true, //是否将 tooltip 框限制在图表的区域内
              enterable: true, //鼠标可进入提示框
              borderWidth: 0, //设置自定义边框宽度
              backgroundColor: 'none', //设置自定义背景
              extraCssText:
                //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
                'backdrop-filter: blur(10px);max-height:400px;overflow:auto;',
              formatter: params => {
                var relVal = `<div style='font-weight: 500;line-height: 20px;color: @text-color-secondary;'>${_this.str}在${params[0].name}:</div>`
                for (var i = 0, l = params.length; i < l; i++) {
                  relVal += `<div class="toolTip">${params[i].marker}${
                    params[i].seriesName
                  }：${params[i].value}${_this.$t('exam.ren')}，${
                    list[i][`${params[0].name}Percent`]
                  }%</div>`
                }
                return relVal
              }
            },
            legend: {
              data: legendData,
              selected: {
                ...lenObj
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              data: this.titles
            },
            yAxis: {
              type: 'value',
              scale: true,
              name: _this.$t('exam.peopleNum'),
              nameTextStyle: {
                color: '#333'
              }
            },
            // dataZoom: [
            //   {
            //     type: 'slider',
            //     start: 0,
            //     end: endVal
            //   },
            //   {
            //     start: 0,
            //     end: endVal
            //   }
            // ],
            series: seriesData
          }

          this.beforeEchart(option, [...avg])
          this.cScroll(option, this.titles, 10)
          this.charts.setOption(option)
          this.charts.resize({ height: legendHeight })
        })
      },
      getTable() {
        //获取分数段,位次段
        this.loading = true
        let {
          meId,
          dId,
          seId,
          classId,
          schoolId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let urlObj = {
          chartH: [
            //分数段接口
            'getscoreseglist',
            'getscoreseglistUnion',
            'getscoreseglistUnion'
          ],
          chartI: [
            //位次段接口
            'getrankseglist',
            'getrankseglistUnion',
            'getrankseglistUnion'
          ]
        }
        let obj = {}
        if (this.$store.state.unionReport) {
          obj = { schoolId }
        } else {
          obj = { classId }
        }

        let params = {
          meId,
          seId,
          dId,
          campusId,
          ...obj
        }

        let url = urlObj[this.id][examIsActive]
        const columnLists = getCol(url)
        // if (columnLists) this.columns = [...columnLists]
        let columnArr = [this.columnsS, columnLists, this.columnsSU]
        this.columns = [...columnArr[examIsActive]]

        axios({
          url,
          params,
          loading: false,
          getCache: this.cache,
          cacheData: this.cacheData
        })
          .then(res => {
            if (res.data.length) {
              this.loading = false
              this.data = res.data
              let legendData = []
              let seriesData = []
              this.titles = res.data[0].ScoreList.map(item => item.Name)
              this.titles.forEach(item => {
                this.columns.push({
                  title: item,
                  children: [
                    {
                      title: 'N',
                      dataIndex: item + 'Num',
                      key: item + 'Num',
                      align: 'center',
                      width: 100
                    },
                    {
                      title: '%',
                      dataIndex: item + 'Percent',
                      key: item + 'Percent',
                      align: 'center',
                      width: 100
                    }
                  ]
                })
              })
              this.data.map(item => {
                if (classId * 1 && item.ClassID == classId) {
                  this.currentClass = { ...item }
                }
                let obj = {
                  name: item.ClassName,
                  type: 'line',
                  // showSymbol: false,
                  symbol: 'circle',
                  symbolSize: 8,
                  // itemStyle: {
                  //   normal: {
                  //     lineStyle: {
                  //       width: 2
                  //     }
                  //   }
                  // },
                  smooth: true,
                  data: []
                }
                item.ScoreList.forEach(sc => {
                  item[sc.Name + 'Num'] = sc.Num
                  item[sc.Name + 'Percent'] = sc.Percent
                  obj.data.push(sc.Num)
                })
                seriesData.push(obj)
                legendData.push(item.ClassName)
              })
              this.renderChart(legendData, this.data, seriesData)
            }
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      importTo() {
        let {
          meId,
          seId,
          dId,
          schoolId,
          examIsActive = 1,
          campusId,
          classId
        } = this.$route.query
        let urlObj = {
          chartH: [
            'exportscoreseg',
            'exportscoresegUnion',
            'exportscoresegUnion'
          ],
          chartI: ['exportrankseg', 'exportranksegUnion', 'exportranksegUnion']
        }
        let obj = {}
        if (examIsActive == 0) {
          obj = { classId }
        } else {
          obj = { schoolId }
        }
        let queryParams = {
          meId,
          seId,
          dId,
          campusId,
          ...obj
        }
        let queryList = []
        for (let q in queryParams) {
          if (queryParams[q] !== undefined) {
            queryList.push(`${q}=${queryParams[q]}`)
          }
        }
        let api = urlObj[this.id][examIsActive]
        let url =
          `${ApiXy.defaulteApi.host}${ApiXy.defaulteApi.path[api]}?` +
          queryList.join('&') +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')
        window.open(url, '_blank', '')
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 4px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  /deep/.current {
    background: rgba(60, 100, 239, 0.2);
    td {
      background: none !important;
    }
  }
  .score {
    height: 100%;
    .left {
      float: left;
    }
    .right {
      float: right;
    }
    .top_div {
      min-height: 400px;
      margin-bottom: @padding-sm;
      .echarts {
        .echarts_list {
          width: 100%;
          min-height: 400px;
        }
      }
    }
    // .table_div {

    // }
  }
</style>
